import {AxiosResponse} from 'axios';
import {IndividualPlanAiGenerated} from '../backend/responses/individual-plan-ai-generated';
import {BackendApiManager} from '../managers/backend-api';
import {Logger} from '../utils/managers/logger';

export class EntityUserIndividualPlansRepository {
  // Singleton Instance
  private static _instance: EntityUserIndividualPlansRepository;

  // Private
  private logger: Logger;

  static get instance(): EntityUserIndividualPlansRepository {
    if (!this._instance) {
      this._instance = new EntityUserIndividualPlansRepository();
    }
    return this._instance;
  }

  constructor() {
    // Create Logger
    this.logger = new Logger('EntityUserIndividualPlansRepository');
  }

  /**
   * Asks the AI for an individual plan proposal. Nothing is saved by this call.
   *
   * @param focus Optional free text with the clinical topic to focus on. Without it, the AI
   * generates an automatic plan.
   */
  public async generateIndividualPlanByAi(
    entityId: string,
    userId: string,
    focus?: string
  ): Promise<IndividualPlanAiGenerated> {
    // Set url
    const url: string = `/entities/${entityId}/users/${userId}/individual-plans/ai-generated`;

    // Post to backend (the focus is only sent when there is one)
    const trimmedFocus = focus?.trim();
    const response: AxiosResponse<IndividualPlanAiGenerated> =
      await BackendApiManager.instance.post<IndividualPlanAiGenerated>(
        url,
        trimmedFocus ? {focus: trimmedFocus} : {}
      );

    // Return
    return response.data;
  }
}
